import { render, staticRenderFns } from "./SectionDropdowns.vue?vue&type=template&id=21eec4d8&scoped=true&"
import script from "./SectionDropdowns.vue?vue&type=script&lang=js&"
export * from "./SectionDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./SectionDropdowns.vue?vue&type=style&index=0&id=21eec4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eec4d8",
  null
  
)

export default component.exports